// extracted by mini-css-extract-plugin
export default {"gpa__userAccount_setting_wrapper":"DropdownMenu_gpa__userAccount_setting_wrapper__IOSo4","gpa__dark_mode":"DropdownMenu_gpa__dark_mode__edvz1"};